// extracted by mini-css-extract-plugin
export default {"formHeading":"_F-z","form":"aG-z","submitBtn":"bG-z","disabled":"cG-z","input":"dG-z","error":"eG-z","submitMsg":"fG-z","signIn":"gG-z"};